module.exports = __webpack_public_path__ + "static/media/(000078).a4dcc7da.jpg";